import { Outlet } from 'react-router-dom';
import Footer from '@/components/organisms/Footer';
import { SidebarProvider } from '../atoms/Sidebar';
import { AppSidebar } from '../organisms/AppSidebar';
import { useDetectMobile } from '@/hooks/useDetectMobile';
import { getCookie } from '@/utils/cookies';
import { AppNavbar } from '../organisms/AppNavbar';
import { SidebarInset } from '../atoms/Sidebar';
import { useLocalStorage } from 'usehooks-ts';
import { InstallBanner } from '../organisms/InstallBanner';
import ScrollToTop from '@/routes/ScrollToTop';

type RootlayoutProps = {
  isViewFooter?: boolean;
  bgColor?: string;
};

const OrderRootLayout = ({ bgColor = 'bg-gr-50', isViewFooter = false }: RootlayoutProps) => {
  useDetectMobile();

  const defaultOpen = getCookie('sidebar_state') === 'true' ? true : false;
  // const [isBannerVisible] = useLocalStorage('isBannerVisible', true);

  return (
    <div className="flex h-[100dvh] flex-col">
      <ScrollToTop />

      {/* <section
        className={` transition-all duration-200 ${
          isBannerVisible ? 'h-[48px] opacity-100' : 'h-0 opacity-0'
        }`}
      >
        <InstallBanner />
      </section> */}
      <div className="flex flex-1 overflow-hidden">
        <SidebarProvider
          style={{
            ['--sidebar-width' as any]: '220px',
            // ['--sidebar-top' as any]: isBannerVisible ? '48px' : '0px',
            ['--sidebar-top' as any]: '0px',
          }}
          className="flex h-full bg-white transition-all duration-300"
          defaultOpen={true}
        >
          {/* height 계산된 사이드바 */}

          <AppSidebar />
          <SidebarInset>
            <div className={`z-[5] flex h-full w-full flex-col  border  ${bgColor}`}>
              {/* 메인 컨텐츠 */}
              <div className="flex w-full">
                <AppNavbar />
              </div>
              <div className="w-full flex-1 overflow-y-scroll">
                <Outlet />
              </div>
            </div>
          </SidebarInset>
        </SidebarProvider>
      </div>
    </div>
  );
};

export default OrderRootLayout;
